import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

function Privacypolicy() {

  return (
    
    <div>
      <Header />
       <main>
     <section
    className="gj hj i pg"
    style={{
      marginTop: "80px", // if your header is 80px height
      backgroundImage: "url('images/privac.jpg')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    }}
  >
   
  </section>

     <section className="i ji">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
        <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
    GDPR Policy
        </h2></motion.section>
      </div>
      <br/>
   <div className="bb uigy5 jutfy">
      <h2 className="ek yj mk gb">1. Introduction</h2>
      <p className="mb-4 pdt1">
        We are committed to protecting your personal data and respecting your privacy. This GDPR Policy explains how we collect, use, store, and protect personal information in accordance with the EU General Data Protection Regulation (GDPR).
      </p>
      
    </div>
     <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">2. Data Controller</h2>
      <p className="mb-4 pdt1">
        <ul>
           <li>🏢 <b>Company:</b> Pinakinedge Media Pvt. Ltd.</li>
          <li>📧 <b>Email:</b> info@pinakinedgemedia.com</li>
          <li>🌐 <b>Website:</b> www.pinakinedgemedia.com</li>
         
        </ul>
       </p>
    </div>


       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">3. Personal Data We Collect</h2>
      <p className="mb-4 ">
      We may collect and process the following data:
       <br/>
        <ul>
          <li>•	Name, email address, phone number</li>
          <li>•	Business or company details</li>
          <li>•	IP address, browser type, device information</li>
          <li>•	Usage data (pages visited, time spent, interactions)</li>
          <li>•	Any information you voluntarily submit via forms or emails</li>
        </ul>
      </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">4. Legal Basis for Processing</h2>
      <p className="mb-4 ">
        We process personal data based on:
        <br/>
        <ul>
          <li>•	Your consent</li>
          <li>•	Contractual necessity</li>
          <li>•	Legal obligations</li>
          <li>•	Legitimate business interests that do not override your rights</li>
        </ul>
      </p>
    </div>

        <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">5. How We Use Your Data</h2>
      <p className="mb-4 "> We comply with:
       <br/>
      
        <ul>
          <li>•	Your data may be used to:</li>
          <li>•	Provide and improve our services</li>
          <li>•	Respond to inquiries and support requests</li>
          <li>•	Send important service or product updates</li>
          <li>•	Ensure website security and performance</li>
          <li>•	Meet legal and regulatory requirements</li>
          
        </ul>
      </p>
    </div>
     <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">6. Data Sharing</h2>
      <p className="mb-4 ">
     We do not sell personal data. We may share data with:
      <br/>
      </p>
        <p className="mb-4 ">
          
          <ul>
            <li>•	Trusted service providers (IT, hosting, analytics)</li>
            <li>•	Legal or regulatory authorities when required by law</li>
          </ul>
        </p>
      <p className="mb-4 pdt1">
    All third parties are required to comply with GDPR standards.
     </p> 
    </div>

      <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">7. Data Retention</h2>
      <p className="mb-4 ">
      Personal data is retained only as long as necessary for the purposes stated or as required by law.
      </p>
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">8. Your GDPR Rights</h2>
      <p className="mb-4 ">
    Under GDPR, you have the right to:
      </p>
     <p className="mb-4 ">
      <ul>
        <li>
        •	Access your personal data</li>
<li>•	Request correction or deletion</li>
<li>•	Restrict or object to processing</li>
<li>•	Data portability</li>
<li>•	Withdraw consent at any time</li>
<li>•	Lodge a complaint with a data protection authority</li>
      </ul>
     </p>
     <p className="mb-4 pdt1">
     Requests can be sent to: info@pinakinedgemedia.com
     </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">9. Data Security</h2>
      <p className="mb-4 ">
 We implement appropriate technical and organizational measures to protect personal data against unauthorized access, loss, or misuse.
      </p>
     
     
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">10. Cookies & Tracking</h2>
      <p className="mb-4 ">
        Our website may use cookies to enhance user experience. You can manage cookie preferences through your browser settings or our cookie banner.
      </p>
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">11. International Data Transfers</h2>
      <p className="mb-4 ">
        If data is transferred outside the EU/EEA, we ensure adequate safeguards such as Standard Contractual Clauses (SCCs).
      </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">12. Policy Updates</h2>
      <p className="mb-4 ">
        We may update this GDPR Policy from time to time. Any changes will be posted on this page with a revised effective date.
      </p>
    </div>

 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">13. Contact Us</h2>
      <p className="mb-4 ">
      For GDPR-related questions or requests, contact:
      </p>
       <p className="mb-4 pdt1">
        <ul>
          <li>📧 <b>Email:</b> info@pinakinedgemedia.com</li>
          <li>🏢 <b>Company:</b> Pinakinedge Media Pvt. Ltd.</li>
            <li>🌐 <b>Website:</b> www.pinakinedgemedia.com</li>
        </ul>
       </p>
    </div>
    </section>
  
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Privacypolicy;
